import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { getActivityLog } from '../services/api';

const ActivityLog = () => {
    const [timelineItems, setTimelineItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAndFormatActivityLog = async () => {
            try {
                const response = await getActivityLog();
                const log = response.data;
                const formattedItems = [];

                if (log.last_login_at) {
                    formattedItems.push({
                        icon: 'bi-box-arrow-in-right',
                        color: 'text-success',
                        title: 'Logged In',
                        description: `Successfully logged in from IP: ${log.last_login_ip || 'N/A'}`,
                        timestamp: log.last_login_at,
                    });
                }

                if (log.last_password_change) {
                    formattedItems.push({
                        icon: 'bi-key-fill',
                        color: 'text-warning',
                        title: 'Password Changed',
                        description: 'Your account password was changed.',
                        timestamp: log.last_password_change,
                    });
                }

                formattedItems.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                setTimelineItems(formattedItems);

            } catch (err) {
                setError('Failed to fetch activity log.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAndFormatActivityLog();
    }, []);

    if (loading) {
        return (
            <Layout title="Activity Log">
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </Layout>
        );
    }

    if (error) {
        return <Layout title="Activity Log"><div className="alert alert-danger">{error}</div></Layout>;
    }

    return (
        <Layout title="Activity Log">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header bg-transparent border-0 pt-4 px-4 pb-0">
                            <h4 className="mb-0 fw-bold">Recent Account Activity</h4>
                        </div>
                        <div className="card-body p-4">
                            {timelineItems.length > 0 ? (
                                <ul className="activity-timeline">
                                    {timelineItems.map((item, index) => (
                                        <li key={index} className="timeline-item">
                                            <div className={`timeline-icon ${item.color}`}>
                                                <i className={`bi ${item.icon}`}></i>
                                            </div>
                                            <div className="timeline-content">
                                                <strong>{item.title}</strong>
                                                <p className="mb-1 text-muted">{item.description}</p>
                                                <small className="text-muted">{new Date(item.timestamp).toLocaleString()}</small>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="text-center p-5">
                                    <i className="bi bi-clock-history fs-1 text-muted"></i>
                                    <h5 className="mt-3">No Recent Activity</h5>
                                    <p className="text-muted">We couldn't find any recent activity on your account.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ActivityLog;
